<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Send, Phone, Mail, Linkedin } from 'lucide-vue-next'

import BaseIcon from '@/components/BaseIcon.vue'
import { useResume } from '@/composables/useResume'

const { content } = useResume()
const { t } = useI18n()

const contact = computed(() => content.value.contact)
const telHref = computed(() => `tel:${contact.value.phone.replace(/\s/g, '')}`)
const primaryEmail = computed(() => contact.value.emails[0] ?? '')
const mailHref = computed(() => `mailto:${primaryEmail.value}`)
</script>

<template>
  <section id="contact">
    <div class="wrap">
      <div class="contact-card glass-strong glass reveal">
        <div class="eyebrow" style="justify-content: center; position: relative">
          <span class="eyebrow-idx">05 /</span> {{ t('sections.contactEyebrow') }}
        </div>
        <h2 class="contact-title">{{ content.sectionTitles.contact }}</h2>
        <p class="contact-sub">{{ content.sectionTitles.contactSub }}</p>
        <div class="contact-methods">
          <a class="cm" :href="contact.telegramUrl" target="_blank" rel="noopener">
            <span class="ic"><BaseIcon :icon="Send" :size="20" /></span>
            <span class="t"><span class="k">{{ contact.labels.telegram }}</span><span class="v">{{ contact.telegram }}</span></span>
          </a>
          <a class="cm" :href="telHref">
            <span class="ic"><BaseIcon :icon="Phone" :size="20" /></span>
            <span class="t"><span class="k">{{ contact.labels.phone }}</span><span class="v">{{ contact.phone }}</span></span>
          </a>
          <a class="cm" :href="mailHref">
            <span class="ic"><BaseIcon :icon="Mail" :size="20" /></span>
            <span class="t"><span class="k">{{ contact.labels.email }}</span><span class="v">{{ primaryEmail }}</span></span>
          </a>
          <a class="cm" :href="contact.linkedinUrl" target="_blank" rel="noopener">
            <span class="ic"><BaseIcon :icon="Linkedin" :size="20" /></span>
            <span class="t"><span class="k">{{ contact.labels.linkedin }}</span><span class="v">{{ contact.linkedin }}</span></span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
